import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { Key } from "../key-handler/Key";
export var TextInput = React.memo(function (_a) {
    var value = _a.value, onChange = _a.onChange, style = _a.style, placeholder = _a.placeholder, minLength = _a.minLength, maxLength = _a.maxLength, onSubmit = _a.onSubmit;
    var inputFieldClass = style ? style + " " + IdStyles.TextNormal : IdStyles.TextNormal;
    var onChangeFn = function (text) { return onChange(text); };
    var handleKeydown = function (event) {
        if (event.keyCode === Key.Enter && onSubmit) {
            onSubmit();
        }
    };
    return (React.createElement("div", { className: "text-input" },
        React.createElement("input", { className: inputFieldClass, type: "text", value: value, onChange: function (event) { return onChangeFn(event.target.value); }, placeholder: placeholder, minLength: minLength, maxLength: maxLength, onKeyDown: handleKeydown }),
        React.createElement("div", { className: "text-input__icon" },
            React.createElement(Icon, { icon: IdIcon.PenIcn, styleId: IdStyles.IconSmall }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/text-input/TextInput.tsx
// module id = 362
// module chunks = 3